import {action, observable} from 'mobx';
import {Auth, NotificationService} from '../services';
import {UserInfo, UserPermissions} from '../models';
import {UserSettings} from '../components';

export class UserStore {
    @observable userInfo: UserInfo;
    @observable userLoaded: boolean;
    @observable errorLoadingUser: boolean;

    private authService: Auth;
    private notificationService: NotificationService;

    constructor(notificationService: NotificationService) {
        // init observables
        this.userLoaded = false;
        this.errorLoadingUser = false;

        // init class members
        this.authService = new Auth();
        this.notificationService = notificationService;
    }

    @action loadUser() {
        return this.authService.getUserInfo()
            .then((user: UserInfo) => {
                this.userInfo = user;
                this.userLoaded = true;
            })
            .catch(() => {
                this.userLoaded = false;
                this.errorLoadingUser = true;

                this.notificationService.addError('Error loading user info.');
            });
    }
    
    @action checkUserRole(role: string) {
        return this.authService.userHasRole(role);
    }

    @action userRoleIn(roles: string[]) {
        return this.authService.userRoleIn(roles);
    }

    @action checkUserPermission(permission: UserPermissions) {
        if (!this.userLoaded) {
            return false;
        }

        if (this.userInfo.userPermissions == null || this.userInfo.userPermissions.length === 0) {
            return false;
        }

        // make sure all user permissions are lower case
        const lowerCasePermissions = this.userInfo.userPermissions.map( x => {
            try {
                return x.toLowerCase();
            }
            catch {
                console.log(`User has unrecognized permission: ${x}`);
            }
            return x;
        });

        return lowerCasePermissions.includes(permission.toLowerCase());
    }

    @action updateAvatar(base64string: string) {
        this.userInfo.avatar = base64string;
    }

    @action mergeUpdatedUserSettings(userSettings: UserSettings) {
        Object.assign(this.userInfo, userSettings);
    }

    get userRole(): string {
        return this.authService.currentRole();
    }
}


// WEBPACK FOOTER //
// ./src/stores/UserStore.tsx